import React, { useState, useRef, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Button, Modal, InputGroup, InputGroupAddon, Input, Form, FormGroup } from 'reactstrap';
import styled from "styled-components";
import { IconContext } from 'react-icons';
import { GrFormDown } from 'react-icons/gr';

import { getDisbursementSetting } from "../../../actions/disbursementAction";

import { hasError, convertToRupiah, getCloudImageUrl, formatCurrency, formatCurrencyWithMinus } from '../../../utils';
import { useOutsideAlerter } from '../../../helpers/dom';
import { RESOURCE_URL } from '../../../config';
const userBalanceIcon = `${RESOURCE_URL}icons/kickcredit.png`;
import { FormFeedback } from '../../Forms';

const isDisabled = (value, max, isSelectedType, receiveAmount, isGettingFee) => {
  return isGettingFee || value == 0 || parseInt(value) > parseInt(max) || ((isSelectedType !== 'Seller Credit') ? (parseInt(value) < parseInt(10000)) : (parseInt(receiveAmount) < parseInt(10000)))
}

const ModalCashOut = props => {
  const bankAccount = props.dataBank && Object.keys(props.dataBank).length > 0 ? props.dataBank.account_name + ' / ' + props.dataBank.bank_name + ' / ' + props.dataBank.account_number : null;
  const adminFee = props.dataSetting && Object.keys(props.dataSetting).length > 0 ? props.dataSetting.admin_fee : null;
  const cashOutFee = props.dataSetting && Object.keys(props.dataSetting).length > 0 ? props.dataSetting.cashout_fee : null;
  const receiveAmount = props.amountFee && props.amountFee > 0 ? parseInt(props.value) - parseInt(props.amountFee) : parseInt(props.value);
  const [isOpenCreditType, setOpenCreditType] = useState(false);
  const [isSelectedType, setSelectedType] = useState(props.title);
  const [userBalance, setUserBalance] = useState(props.dataUser.balance);
  const wrapperRefCredit = useRef(null);
  useOutsideAlerter(wrapperRefCredit, () => setOpenCreditType(false));
  const { currency, ratio } = props;

  useEffect(() => {
    if (props.title === "Kick Credit") {
      setUserBalance(props.dataUser.balance)
      setSelectedType("Kick Credit")
    } else if (isSelectedType === "Seller Credit") {
      setUserBalance(props.dataUser.balance_with_fee)
      setSelectedType("Seller Credit")
    }
  }, [props.isOpen])

  useEffect(() => {
    if (isSelectedType === "Seller Credit") {
      props.getDisbursementSetting();
      setUserBalance(props.dataUser.balance_with_fee);

      if (parseInt(props.value) > 0) props.onGetDisbursementFee(parseInt(props.value))
    } else if (isSelectedType === "Kick Credit") {
      setUserBalance(props.dataUser.balance);
      props.onResetDisbursementSetting();
    }
  }, [isSelectedType])

  return (
    <Modal
      modalClassName="modal-cashout-v3"
      isOpen={props.isOpen}
      toggle={props.onToggle}
    >
      <Form
        onSubmit={e => {
          e.preventDefault();
          if (!isDisabled(props.value, userBalance)) props.onNextPage(2, isSelectedType);
        }}
      >
        <div className="cashout-content">
          <div className="cashout-title">
            <span>Cash Out</span>
          </div>
          <div className="cashout-header">
            <div className="cashout-info">
              <div className="balance-icon">
                <KickImage src={getCloudImageUrl(props.icon, 400)} />
              </div>
              <div className="balance-info">
                <span>{isSelectedType}</span>
                <span className={`${parseInt(userBalance) < 0 ? "minus" : ""}`}>{formatCurrencyWithMinus(parseInt(userBalance), ratio, currency)}</span>
              </div>
            </div>
          </div>
          {
            props.hasOptions && (
              <WrapperForm className={'form-parent'}>
                <p>Credit type</p>
                <div
                  className={'text-box'}
                  onClick={() => setOpenCreditType(!isOpenCreditType)}>
                  <p>{isSelectedType}</p>
                  <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
                    <div className={'icon-dropdown'}>
                      <GrFormDown />
                    </div>
                  </IconContext.Provider>
                </div>
                {
                  isOpenCreditType && (
                    <div
                      ref={wrapperRefCredit}
                      className={'search-product-result-container'}>
                      <p style={isSelectedType === "Kick Credit" ? { fontFamily: "Nunito-Bold" } : {}} onClick={() => {
                        setSelectedType("Kick Credit")
                        setOpenCreditType(false)
                      }}>Kick Credit</p>
                      <div className="line" />
                      <p style={isSelectedType === "Seller Credit" ? { fontFamily: "Nunito-Bold" } : {}} onClick={() => {
                        setSelectedType("Seller Credit")
                        setOpenCreditType(false)
                      }}>Seller Credit</p>
                    </div>
                  )
                }
              </WrapperForm>
            )
          }
          {
            isSelectedType === "Seller Credit" && cashOutFee && adminFee ?
              <div className="cashout-fee">
                <div className="cashout-fee-info">
                  <span className="icon-reminder">!</span>
                  <span>{`${props.title} Cash Out Fee ${cashOutFee}% of total cash out + ${formatCurrency(convertToRupiah(parseInt(adminFee)), ratio, currency)}.`}</span>
                </div>
              </div>
              :
              null
          }
          {
            bankAccount ?
              <>
                <div className="text-desc">
                  <p>Cash out to</p>
                </div>
                <FormGroup className="cashout-input">
                  <InputGroup className={classNames({ "is-invalid": hasError(props.error && props.error.errors, 'total_amount') })}>
                    <Input
                      disabled
                      value={bankAccount}
                      name="_value"
                    />
                  </InputGroup>
                </FormGroup>
              </>
              :
              null
          }
          <div className="text-desc">
            <p>Nominal Cash out</p>
          </div>
          <FormGroup className="cashout-input">
            <InputGroup className={classNames({ "is-invalid": hasError(props.error && props.error.errors, 'total_amount') })}>
              <Input
                value={convertToRupiah(parseInt(props.value))}
                onChange={(e) => props.onTextChange(e, isSelectedType)}
                name="_value"
              />
            </InputGroup>
            <FormFeedback errors={props.error && props.error.errors} field="total_amount" />
            {
              parseInt(props.value) > parseInt(userBalance) ?
                <p style={{ color: "#e20000" }}>Maximal Cash Out {parseInt(userBalance) < 0 ? 0 : `${formatCurrency(convertToRupiah(parseInt(userBalance)), ratio, currency)}`}</p>
                :
                (isSelectedType !== 'Seller Credit') ?
                  (parseInt(props.value) < parseInt(10000)) ? <p>Minimal Cash Out {`${formatCurrency(convertToRupiah(parseInt(10000)), ratio, currency)}`}</p> : null :
                  (parseInt(receiveAmount) < parseInt(10000)) ? <p>Minimal Cash Out {`${formatCurrency(convertToRupiah(parseInt(10000)), ratio, currency)}`}</p> : null
            }
          </FormGroup>
          <div className="cashout-button">
            <Button
              className={classNames("cashout-content", { "btn": props.value < userBalance, "btn2": isDisabled(props.value, userBalance, isSelectedType, receiveAmount) || props.isGettingFee })}
              disabled={isDisabled(props.value, userBalance, isSelectedType, receiveAmount, props.isGettingFee)}
              onClick={() => props.onNextPage(2, isSelectedType)}
            >
              NEXT
            </Button>
            {
              isSelectedType === "Seller Credit" && cashOutFee && adminFee && userBalance > 0 ?
                <><span>{`You will receive ${formatCurrency(convertToRupiah(parseInt(receiveAmount >= 0 ? receiveAmount : 0)), ratio, currency)}.`}</span></>
                : null
            }
          </div>
        </div>
      </Form>
    </Modal>
  )
}

const WrapperForm = styled.div`
  padding: 0rem 1rem;
  cursor: pointer;
  p {
    margin-bottom: 7px;
    margin-left: 7px;
    color: #242424;
  }
  .text-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    background-color: transparent;
    border: 1px solid #ced4da;
    border-radius: 10px;
    p {
      margin: 0;
      font-size: 14px;
    }
  }
  .search-product-result-container {
    position: absolute;
    left: 0;
    right: 0;
    /* top: 78px; */
    max-height: 400px;
    overflow-y: auto;
    z-index: 2;
    background-color: #fff;
    /* border-radius: 5px; */
    border: solid 1px #e0e0e0;
    border-top: none;
    /* width: 100%; */
    margin: 0 2.9rem;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
    /* padding: 0 1rem; */
    p {
      margin-bottom: 0;
      padding: 10px 15px;
      &:last-child {
        ${'' /* margin-bottom: 7px; */}
      }
    }
    .line {
      height: 1px;
      background-color: #ccc;
      width: 100%;
    }
  }
`

const mapDispatchToProps = (dispatch) => {
  return {
    getDisbursementSetting: () => dispatch(getDisbursementSetting())
  }
}

const mapStateToProps = (state) => ({
  dataSetting: state.dataDisbursement.disbursementSetting,
  dataUser: state.dataAuth.userdata,
  currency: state.dataAuth.userCurrency.currency,
  ratio: state.dataAuth.userCurrency.ratio,
})

export default connect(mapStateToProps, mapDispatchToProps)(ModalCashOut);